import { Alert } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';
import React from 'react';

import { Link, Typography } from '@occc/ui-design-system';

type OfferSupportAlertProps = {
  title: string;
  fallbackLink: string;
  fallbackLinkTitle: string;
};

export const OfferSupportAlert: React.FC<OfferSupportAlertProps> = ({
  title,
  fallbackLink,
  fallbackLinkTitle,
}) => (
  <Alert severity='error'>
    <Typography gutterBottom>{title}</Typography>
    <Link component={RouterLink} variant='body2' to={fallbackLink}>
      {fallbackLinkTitle}
    </Link>
  </Alert>
);
